
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    name: "CategorySort",
    computed: mapGetters({
        sort: 'getSort',
        productCount: 'getResultsCount',
        productTotalLabel: 'getResultsTotalLabel'
    }),
    methods: mapActions({
        sortProduct: 'SORT_PRODUCTS'
    })
});
